import React, { Component } from "react";
import { CSSTransition } from "react-transition-group";
import "./controls.scss";

import SearchButton from "./SearchButton";
import FilterAllButton from "./FilterAllButton";
import TypeButton from "./TypeButton";
import AboutMapButton from "./AboutMapButton";
import DynamicControlsContent from "./DynamicControlsContent";
import DateFilter from "../sharedComponents/DateFilter";

class ControlsView extends Component {
  renderTest = (test) => {
    if (test) {
      return (
        <DynamicControlsContent
          type={this.props.controlButton.type}
          {...this.props}
        ></DynamicControlsContent>
      );
    }

    return null;
  };
  render() {
    const classNames = this.props.controlButton.hasControl
      ? "control-buttons active"
      : "control-buttons";
    let numberOfAllDataPoints = 0;

    for (const key in this.props.geoJSONDataStatistics) {
      numberOfAllDataPoints =
        numberOfAllDataPoints + this.props.geoJSONDataStatistics[key].all;
    }

    return (
      <div className="controls-container">
        <DateFilter
          setDateFilter={this.props.setDateFilter}
          filterType={"all"}
          dateValues={this.props.dateFilter["all"]}
        ></DateFilter>
        <div className={classNames}>
          <SearchButton onClick={this.props.onClick}></SearchButton>
          <FilterAllButton
            onClick={this.props.onClick}
            numberOfDataPoints={numberOfAllDataPoints}
          ></FilterAllButton>
          <AboutMapButton onClick={this.props.onClick} />

          {Object.keys(this.props.geoJSONData).map(
            function (key) {
              return (
                <TypeButton
                  key={"control-button--" + this.props.geoJSONData[key].name}
                  fullName={this.props.geoJSONData[key].fullName}
                  shortName={this.props.geoJSONData[key].name}
                  onClick={this.props.onClick}
                  numberOfDataPoints={this.props.geoJSONDataStatistics[key].all}
                ></TypeButton>
              );
            }.bind(this)
          )}
        </div>
        <CSSTransition
          in={this.props.controlButton.hasControl}
          timeout={3000}
          classNames="filter-view"
          appear={true}
          unmountOnExit={true}
        >
          <DynamicControlsContent
            type={this.props.controlButton.type}
            {...this.props}
          ></DynamicControlsContent>
        </CSSTransition>
      </div>
    );
  }
}

export default ControlsView;
